import { proxy } from 'valtio';

import { NotificationCategory } from 'helpers/NotificationHelpers';

type InboxFilters = {
    category: NotificationCategory | null;
    unreadOnly: boolean;
    archived: boolean;
    team: string | null;
    company: string | null;
};

const DEFAULT_INBOX_FILTERS: InboxFilters = {
    category: null,
    unreadOnly: false,
    archived: false,
    team: null,
    company: null,
};

const state = proxy<{
    opened: boolean;
    filters: InboxFilters;
}>({
    opened: false,
    filters: { ...DEFAULT_INBOX_FILTERS },
});

export type { InboxFilters };
export { DEFAULT_INBOX_FILTERS, state };
